import React from 'react';

import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';

//Componentes auxiliares:
import InfoCard from '../components/usersManagement/InfoCard';
import HelpButton from '../layouts/mainLayout/components/HelpButton';
import OwnProfileManager from '../components/usersManagement/OwnProfileManager';
import UsersProfileManager from '../components/usersManagement/UsersProfileManager';

//Scripts auxiliares:
import { forceUserLogout } from '../tools/scripts/userRelated';
import { registerAuditProcess } from '../tools/scripts/customFetching';

//Contenido del tour de ayuda:
import { usersManagementTourConfig } from './tours/UsersManagement';

//Constantes auxiliares para sweetalerts:
let deleteConfirmationAlertContent = {
    title: 'Confirmar eliminación del usuario',
    // showClass: { popup: 'animated fadeInDown faster' },
    icon: 'info',
    html: '<p style="font-size: 0.75em; text-align: left;">¿Estás seguro de eliminar al usuario <b>@userEmail</b>? Antes de eliminarlo, recuerda que puedes desactivarlo y que <b>esta acción no tiene vuelta atrás</b>.</p>',
    showCancelButton: true,
    confirmButtonText: 'Confirmar',
    cancelButtonText: 'Cancelar',
    focusCancel: true
}

let updateConfirmationAlertContent = {
    title: 'Clic de confirmación',
    // showClass: { popup: 'animated fadeInDown faster' },
    icon: 'info',
    html: '<p style="font-size: 0.75em; text-align: center">¿Estás seguro de cambiar los permisos a este usuario?</p>',
    showCancelButton: true,
    confirmButtonText:
        'Confirmar',
    cancelButtonText:
        'Cancelar',
}

class UsersManagement extends React.Component {

    constructor() {
        super();

        this.state = {
            usersList: []
        }
    }

    render() {
        return (
            <div className="content">
                <Row>
                    <Col xs="12" md="8" lg="8" xl="8">
                        <OwnProfileManager activeUser={this.props.activeUser} />

                        <div data-tut="reactour__usersManagement.usersManagement">
                            {this.getUsersProfileManagerIfAdmin()}
                        </div>                      
                    </Col>

                    <Col xs="12" md="4" lg="4" xl="4">
                        <div data-tut="reactour__usersManagement.rolesInfoCard">
                            <InfoCard />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

    componentDidMount() {
        this.loadUsersFromBackend();
        
        let tourContent = usersManagementTourConfig;
        if (!(this.props.activeUser.is_admin || this.props.activeUser.is_staff)) {
            tourContent = tourContent.filter(tourItem => tourItem.adminRequired !== true);
        }
        
        this.props.changeRelatedNavbarButtons([
            <HelpButton tourContent={tourContent} />
        ]);
    }

    //Métodos para renderizado:
    getUsersProfileManagerIfAdmin = () => {
        if (this.props.activeUser.is_admin || this.props.activeUser.is_staff) {
            return (
                <UsersProfileManager
                    users={this.state.usersList}
                    deleteUserFunction={this.clickOnDeleteUser}
                    updateUserFunction={this.clickOnUpdateUserInfo}
                    reloadUsersFunction={this.loadUsersFromBackend} />
            );
        }
    }

    //Métodos operativos:
    clickOnDeleteUser = (targetUser) => {
        let myDeleteConfirmationAlertContent = { ...deleteConfirmationAlertContent };
        myDeleteConfirmationAlertContent.html = myDeleteConfirmationAlertContent.html.replace("@userEmail", targetUser.email);

        Swal.fire(myDeleteConfirmationAlertContent)
            .then(result => {
                if (result.value) {
                    this.deleteUser(targetUser)
                }
            });
    }

    clickOnUpdateUserInfo = (targetUser, targetKey) => {
        Swal.fire(updateConfirmationAlertContent)
            .then(result => {
                if (result.value) {
                    this.updateUserInfo(targetUser, targetKey)
                }
            });
    }

    deleteUser = (targetUser) => {
        fetch(process.env.REACT_APP_API_URL + "/users/" + targetUser.id, {
            method: 'delete',
            headers: { 'Authorization': 'Token ' + this.props.activeUser.authToken, 'Content-Type': 'application/json' },
        })
            .then(serverResponse => {
                switch (serverResponse.status) {
                    case 200:
                    case 204:
                        Swal.fire('', 'Usuario <b>eliminado con éxito</b>', 'success');

                        registerAuditProcess(this.props, {
                            "event_type": "USER_DELETED",
                            "description": "El usuario <b>eliminó el acceso a" + targetUser.email + "</b>"
                        });

                        this.loadUsersFromBackend();
                        break;

                    case 401:
                        forceUserLogout();
                        break;

                    default:
                        Swal.fire('', 'El proceso de eliminación de usuario no pudo completarse', 'error');
                        break;
                }
            })
            .catch(error => { console.log(error); Swal.fire('', 'El proceso de eliminación de usuario no pudo completarse', 'error'); });
    }

    loadUsersFromBackend = () => {

        window.document.body.style.cursor = "wait";
        fetch(process.env.REACT_APP_API_URL + "/users/", {
            method: 'get',
            headers: { 'Authorization': 'Token ' + this.props.activeUser.authToken }
        })
            .then(serverResponse => {
                switch (serverResponse.status) {
                    case 200:
                        serverResponse.json()
                            .then(users => {
                                let usersList = users;
                                usersList = usersList.filter(item => item.country_scope === this.props.activeUser.country_scope);
                                this.setState({ usersList: usersList });
                                window.document.body.style.cursor = "default";
                            })
                            .catch(error => {
                                console.log(error);
                                window.document.body.style.cursor = "default";
                            });
                        break;

                    case 401:
                        forceUserLogout();
                        break;

                    default:
                        console.log('No se cargaron adecuadamente los usuarios');
                        window.document.body.style.cursor = "default";
                        break;
                }
            })
            .catch(error => { console.log(error); window.document.body.style.cursor = "default"; });
    }

    updateUserInfo = (targetUser, targetKey) => {
        let updateObject = {};
        updateObject['email'] = targetUser.email;
        updateObject[targetKey] = !targetUser[targetKey];

        fetch(process.env.REACT_APP_API_URL + "/users/" + targetUser.id, {
            method: 'PUT',
            headers: { 'Authorization': 'Token ' + this.props.activeUser.authToken, 'Content-Type': 'application/json' },
            body: JSON.stringify(updateObject),
            mode: 'cors'
        })
            .then(serverResponse => {
                switch (serverResponse.status) {
                    case 200:
                        Swal.fire('', 'Proceso de actualización <b>completado con éxito</b>', 'success');
                        this.loadUsersFromBackend();
                        
                        let roleGrantted;
                        let actionExecuted = (updateObject[targetKey]) ? "asignó" : "quitó";
                        switch (targetKey) {
                            case "is_admin":
                                roleGrantted = "administrador"
                                break;

                            case "is_staff":
                                roleGrantted = "staff"
                                break;

                            case "is_active":
                                roleGrantted = "lector"
                                break;

                            default:
                                roleGrantted = "usuario"
                                break;
                        }

                        registerAuditProcess(this.props, {
                            "event_type": "USER_PERMISSIONS_CHANGED",
                            "description": "El usuario <b>" + actionExecuted + " permisos de "
                                + roleGrantted + "</b> al usuario " + targetUser.email
                        });
                        break;

                    case 401:
                        forceUserLogout();
                        break;

                    default:
                        Swal.fire('', 'El proceso de actualización no pudo completarse', 'error');
                        break;
                }
            })
            .catch(error => { console.log(error); Swal.fire('', 'El proceso de actualización no pudo completarse', 'error'); });
    }

}

const mapdispatchToProps = dispatch => {
    return {
        changeRelatedNavbarButtons: (navbarButtons) => dispatch({ type: "changeNavbarButtons", navbarButtons: navbarButtons })
    };
};

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
        coreBackendHost: state.mainReducer.coreBackendHost,
        enableAuditRegistering: state.mainReducer.enableAuditRegistering
    };
};

export default connect(mapStateToProps, mapdispatchToProps)(UsersManagement);